module.exports = __webpack_public_path__ + "img/facebook.5fbf6ad5.svg";